<ng-container *ngIf="locations">
  <mat-list>
    <atlas-location-list-item
      *ngFor="let location of locations"
      [location]="location"
      class="business-navbar__location-list-item"
      (selected)="onLocationSelected()"
    ></atlas-location-list-item>
  </mat-list>
</ng-container>
